import { render, staticRenderFns } from "./insurer-plan.vue?vue&type=template&id=b5363cce&scoped=true&"
import script from "./insurer-plan.vue?vue&type=script&lang=js&"
export * from "./insurer-plan.vue?vue&type=script&lang=js&"
import style0 from "./insurer-plan.vue?vue&type=style&index=0&id=b5363cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5363cce",
  null
  
)

export default component.exports